<template>
    <section class="overview-reservations-page">
        <div class="comp_scroller">
            <div class="comp_content">
                <div class="wrp_comp_body">
                    <h1>Přijaté rezervace</h1>
                    <OverviewReservations :all="true"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import OverviewReservations from '../part/ui/overview-reservations';

export default {
    name: 'overview-reservations-page',
    components: {OverviewReservations},
    data() {
        return {};
    },
    methods: {}
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/overview-reservations-page.vue